/** @jsx h */
import { h, Component } from 'preact'

import SwipeIcon from '../icons/SwipeIcon'

class SwipePrompt extends Component {
  constructor (props) {
    super(props)
    this.state = {
      hide: true
    }
  }

  componentDidMount () {
    window.setTimeout(() => {
      this.setState({ hide: false })
    }, 400)

    window.setTimeout(() => {
      this.setState({ hide: true })
    }, 2000)
  }

  render () {
    const { hide } = this.state

    return (
      <div class={`SwipePrompt ${hide ? 'SwipePrompt--hidden' : ''}`}>
        <div class='SwipePrompt-inner'>
          <SwipeIcon />
        </div>
      </div>
    )
  }
}

export default SwipePrompt
